import { render, staticRenderFns } from "./PermissionDataRuleModal.vue?vue&type=template&id=6357af0a&scoped=true"
import script from "./PermissionDataRuleModal.vue?vue&type=script&lang=js"
export * from "./PermissionDataRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357af0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6357af0a')) {
      api.createRecord('6357af0a', component.options)
    } else {
      api.reload('6357af0a', component.options)
    }
    module.hot.accept("./PermissionDataRuleModal.vue?vue&type=template&id=6357af0a&scoped=true", function () {
      api.rerender('6357af0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/PermissionDataRuleModal.vue"
export default component.exports